import Input from '../../common/Input';

export default function Step2_MovingDetails({ register, errors }) {
  return (
    <section>
      <h2>2. Detalji selidbe</h2>
      <h3>Polazak</h3>
      <Input label="Grad" {...register('from.city', { required: 'Obavezno' })} error={errors?.from?.city?.message} />
      <Input label="Ulica" {...register('from.street')} />
      <Input label="Sprat" type="number" {...register('from.floor', { valueAsNumber: true })} />
      <label><input type="checkbox" {...register('from.elevator')} /> Ima lift</label>

      <h3>Dolazak</h3>
      <Input label="Grad" {...register('to.city', { required: 'Obavezno' })} error={errors?.to?.city?.message} />
      <Input label="Ulica" {...register('to.street')} />
      <Input label="Sprat" type="number" {...register('to.floor', { valueAsNumber: true })} />
      <label><input type="checkbox" {...register('to.elevator')} /> Ima lift</label>

      <Input label="Željeni datum" type="date" {...register('date')} />
    </section>
  );
}
